<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-33 md-small-size-100">
      <md-field :class="{ 'md-error': errors.has('specialization') }">
        <label for="specialization">Eye Care Provider</label>
        <md-select v-validate="'required'" v-model="specialization" name="specialization" data-vv-name="specialization">
          <md-option v-for="(item, index) in specializationList" :key="item.LookupId" :value="item.LookupId">
            {{ item.Value }}
          </md-option>
        </md-select>
      </md-field>
    </div>

    <div class="md-layout-item md-size-33 md-small-size-100">
      <md-field :class="{ 'md-error': errors.has('subspecialization') }">
        <label for="subspecialization">Eye Care Specialty</label>
        <md-select v-validate="[341, 343].indexOf(specialization) >= 0 ? 'required' : ''" v-model="subspecialization"
          name="subspecialization" data-vv-name="subspecialization">
          <md-option v-for="(item, index) in subspecializationsList" :key="item.LookupId" :value="item.LookupId">
            {{ item.DisplayValue }}
          </md-option>
        </md-select>
      </md-field>
    </div>

    <div class="md-layout-item md-size-33 md-small-size-100">
      <md-field :class="{ 'md-error': errors.has('specialties') }">
        <label for="specialties">Non-Eye Care Provider</label>
        <md-select v-model="specialties" name="specialties" data-vv-name="specialties">
          <md-option v-for="(item, index) in specialtiesList" :key="item.LookupId" :value="item.LookupId">
            {{ item.DisplayValue }}
          </md-option>
        </md-select>
      </md-field>
    </div>

    <div class="md-layout-item md-size-50 md-small-size-100">
      <md-field :class="{ 'md-error': errors.has('boardCertified') }">
        <label for="boardCertified">Are you Board Certified?</label>
        <md-select v-validate="'required'" v-model="boardCertified" name="boardCertified" data-vv-name="boardCertified">
          <md-option value="Yes">Yes, I am Board Certified</md-option>
          <md-option value="No">No, I am not Board Certified</md-option>
          <md-option value="Pending">My Board Certification is pending</md-option>
        </md-select>
      </md-field>
    </div>

    <div class="md-layout-item md-size-50 md-small-size-100">
      <md-field :class="[
        { 'md-valid': !errors.has('certdate') && touched.certdate },
        { 'md-form-group': true },
        { 'md-error': errors.has('certdate') }
      ]">
        <md-icon>today</md-icon>
        <label for="certdate">Certification Date</label>
        <md-input style="border-bottom: solid 1px lightgray !important;" id="certdate" v-model="certdate"
          placeholder=" " data-vv-name="certdate" name="certdate" type="date" />
      </md-field>
    </div>

    <div class="md-layout-item md-size-80 mt-4 md-small-size-100">
      <md-field :class="{ 'md-error': errors.has('CAQH') }">
        <md-icon>verified_user</md-icon>
        <label>CAQH Number #</label>
        <md-input v-model="CAQH" data-vv-name="CAQH" type="text" name="CAQH" />
      </md-field>

      <md-field :class="{ 'md-error': errors.has('NPI') }">
        <md-icon>verified_user</md-icon>
        <label>NPI Number #</label>
        <md-input v-model="NPI" data-vv-name="NPI" type="text" name="NPI" />
      </md-field>

      <md-field :class="{ 'md-error': errors.has('License') }">
        <md-icon>verified_user</md-icon>
        <label>License Number #</label>
        <md-input v-model="License" data-vv-name="License" type="text" name="License" />
      </md-field>
    </div>
  </div>
</template>

<script>
import { SlideYDownTransition } from "vue2-transitions"
import { mapGetters, mapActions } from "vuex"

export default {
  components: {
    SlideYDownTransition
  },
  data() {
    return {
      renderCertDate: false,
      specialization: "",
      subspecialization: "",
      specialties: "",
      boardCertified: "",
      certdate: null,
      CAQH: "",
      NPI: "",
      License: "",
      touched: {
        specialization: false,
        subspecialization: false,
        specialties: false,
        boardCertified: false,
        certdate: false,
        CAQH: false,
        NPI: false,
        License: false
      },
      modelValidations: {
        CAQH: {
          required: false,
          min: 0
        },
        NPI: {
          required: false,
          min: 0
        },
        License: {
          required: false,
          min: 0
        }
      },
      specializationList: [],
      subspecializationsList: [],
      specialtiesList: []
    }
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["drCredentials"])
  },
  watch: {
    boardCertified() {
      if (this.boardCertified != "Yes") {
        this.certdate = ""
      }
    },
    drCredentials() {
      this.fillCredentialData()
    }
  },
  mounted() {
    this.defineLookups()
  },
  methods: {
    ...mapActions(["listLookupsByMasterName"]),
    fetchLookupByName(name) {
      return this.listLookupsByMasterName(name)
    },
    sortByDisplayName(arr) {
      return arr.slice().sort((a, b) => a.DisplayValue.localeCompare(b.DisplayValue))
    },
    async defineLookups() {
      try {
        const specialization = await this.fetchLookupByName("Qualifications")
        this.specializationList = this.sortByDisplayName(specialization)
        const subSpecialization = await this.fetchLookupByName("Subspecializations")
        this.subspecializationsList = this.sortByDisplayName(subSpecialization)
        const specialties = await this.fetchLookupByName("Specialities")
        this.specialtiesList = this.sortByDisplayName(specialties)
        this.fillCredentialData()
      } catch (error) {
        console.error("Error fetching lookups:", error)
      }
    },
    displayToLookup(lookupList, id) {
      let lookupItem = lookupList.find((item) => item.LookupId === +id)
      if (lookupItem) {
        return lookupItem.LookupId
      } else {
        return null
      }
    },
    fillCredentialData() {
      if (!this.isEdit) return
      this.certdate = this.drCredentials.certDate ? new Date(this.drCredentials.certDate).toISOString().split("T")[0] : ""

      this.specialization = this.displayToLookup(this.specializationList, this.drCredentials.specialization) || ""
      this.subspecialization =
        this.displayToLookup(this.subspecializationsList, this.drCredentials.subSpecialization) || ""
      this.specialties = this.displayToLookup(this.specialtiesList, this.drCredentials.specialties) || ""
      this.boardCertified = this.drCredentials.ruCertified || false
      this.CAQH = this.drCredentials.CAQH || ""
      this.NPI = this.drCredentials.NPI || ""
      this.License = this.drCredentials.LICENSE || ""
    },
    validate() {
      this.storeValues()
      return this.$validator.validateAll().then((res) => {
        this.$emit("on-validated", res)
        return res
      })
    },
    storeValues() {
      this.drCredentials.specialization = this.specialization
      this.drCredentials.subSpecialization = this.subspecialization
      this.drCredentials.specialties = this.specialties
      this.drCredentials.ruCertified = this.boardCertified
      this.drCredentials.certDate = this.certdate
      this.drCredentials.CAQH = this.CAQH
      this.drCredentials.NPI = this.NPI
      this.drCredentials.LICENSE = this.License
    }
  }
}
</script>
<style>
:root {
  --gray: #999;
  --blue: #0074d9;
  --color: #333;
  --background-color: #fff;
  --border: 1px solid #eee;
}

.md-menu-content {
  z-index: 9998 !important;
}
</style>
